import { createContext, useContext } from 'react';
import type { RotaData } from '../data/rota';

export const RotaContext = createContext<RotaData | null>(null);
export function useRota() {
  const rota = useContext(RotaContext);
  if (!rota) throw new Error('Rota provider is missing');
  return rota;
}
